/**
 * @generated SignedSource<<efd863e943a8d96a0fde50a3009b4983>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMergedSponsoredAndYmalItems_similarItems$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsLanding_similarItem">;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "useMergedSponsoredAndYmalItems_similarItems";
};
export type useMergedSponsoredAndYmalItems_similarItems$key = {
  readonly " $data"?: useMergedSponsoredAndYmalItems_similarItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMergedSponsoredAndYmalItems_similarItems">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMergedSponsoredAndYmalItems_similarItems",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "moreLikeThisItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemsLanding_similarItem"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "moreLikeThisItemConnection",
  "abstractKey": null
};

(node as any).hash = "6759a2a12f088190968d881d25711d5c";

export default node;
